<template>
  <section class="admin">
    <div class="app">
      <div class="mobile-menu md:hidden">
        <div class="mobile-menu-bar">
          <a href="" class="flex mr-auto">
            <img alt="My Inxait" class="w-6" src="/static/FAVICON-2026.png" />
          </a>
          <a href="javascript:;" @click="menuMobile">
            <app-icon
              name="bars"
              classname="w-8 h-8 text-white transform -rotate-90"
            />
          </a>
        </div>
        <ul class="border-t border-theme-29 py-5 d-block" v-if="!openmenu">
          <app-side-bar classname="menu" />
        </ul>
      </div>
      <div class="flex">
        <nav class="side-nav">
          <a href="#" class="intro-x flex items-center pl-5 pt-4">
            <img
              alt="Logo"
              class="w-32 xl:block"
              src="/static/images/LOGO-WHITE-2026.png"
            />
          </a>
          <div class="side-nav__devider my-6"></div>
          <app-side-bar classname="side-menu" />
        </nav>
        <div class="content">
          <app-top />
          <app-loading v-if="isLoading" />
          <router-view v-else />
        </div>
        <modal-password-updated
          v-if="user.id && user.lastPasswordUpdated != true"
        ></modal-password-updated>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/admin/partials/Top'
import Icon from '@/components/admin/partials/Icon'
import SideBar from '@/components/admin/partials/SideBar'
import Loading from '@/components/admin/partials/LoadingWhite'
import ModalPasswordUpdated from '@/components/admin/profile/ModalPasswordUpdated'

export default {
  data() {
    return {
      openmenu: true,
    }
  },
  methods: {
    menuMobile() {
      var menu = this.openmenu
      console.log('clic')
      this.openmenu = !menu
    },
  },
  created() {},
  computed: {
    ...mapGetters({ user: 'getUser', isLoading: 'getIsLoading' }),
  },
  components: {
    appTop: Top,
    appIcon: Icon,
    appSideBar: SideBar,
    appLoading: Loading,
    ModalPasswordUpdated,
  },
}
</script>



// WEBPACK FOOTER //
// Admin.vue?3986b334